export const SPLIT_BUTTON_ICON_SIZES = {
  xs: '100',
  sm: '100',
  md: '200',
  lg: '200',
  xl: '300',
};

export default {
  SPLIT_BUTTON_ICON_SIZES,
};
